export const defaultModalTrigger = {
    '@type': '@builder.io/sdk:Element',
    component: {
        name: 'ModalTrigger'
    },
    children: [
        {
            component: {
                name: 'Text',
                options: {
                    text: '<p>Modal<span style="color: inherit; font-family: inherit; font-size: inherit; font-weight: inherit; letter-spacing: inherit; text-align: inherit; background-color: transparent;">&nbsp;Trigger</span></p>'
                }
            }
        },
        {
            '@type': '@builder.io/sdk:Element',
            component: {
                name: 'IconPicker',
                options: {
                    iconName: 'Info'
                }
            },
            responsiveStyles: {
                large: {
                    width: '20px',
                    marginBottom: '2px',
                    marginLeft: '4px'
                }
            }
        }
    ],
    responsiveStyles: {
        large: {
            display: 'flex',
            flexDirection: 'row',
            borderWidth: '2px',
            borderStyle: 'solid',
            borderRadius: '10px',
            paddingLeft: '10px',
            paddingRight: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '5px',
            paddingBottom: '5px'
        }
    }
}

export const defaultModelContent = {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-08830198e8a6436c91ffeba015b1795e',
    component: {
        name: 'ModalContent',
        options: {}
    },
    responsiveStyles: {
        large: {
            width: '800px'
        }
    }
}
